import { createFileRoute } from "@tanstack/react-router"
import { InvoiceEditPage } from "@/pages"
import { AuthorizationGate } from "@/components"
import { Resource, Action } from "@mimber/schema"

export const Route = createFileRoute(
  "/_authenticated/_organization/finance/invoices/$invoiceUuid/edit"
)({
  component: () => (
    <AuthorizationGate resource={Resource.INVOICE} action={Action.UPDATE}>
      <InvoiceEditPage />
    </AuthorizationGate>
  ),
})
